import { ref } from 'vue';
import { defineStore } from 'pinia';

import { useResumesStore } from './resumes.store.js';

export const useSelectResumeStore = defineStore('selectResumeStore', () => {
	const selectedResume = ref(null);
	const isResumeModalVisible = ref(false);
	const isUploadCustomModalVisible = ref(false);
	const showUnableToTailorModal = ref(false);
	const showSideTab = ref(false);
    
	const unableToTailorJobTitle = ref(null);
	const unableToTailorError = ref(null);

	const resumesStore = useResumesStore();
    
	const hideSideTab = () => {
		showSideTab.value = false;
	};
    
	const setShowSideTab = () => {
		showSideTab.value = true;
	};
    
	const showResumeModal = () => {
		selectedResume.value = null;
		isResumeModalVisible.value = true;

		resumesStore.fetchResumes();
	};
    
	const setShowUnableToTailorModal = (explanation, jobTitle) => {
		unableToTailorError.value = explanation;
		unableToTailorJobTitle.value = jobTitle;
        
		showUnableToTailorModal.value = true;
	};
    
	const hideUnableToTailorModal = () => {
		selectedResume.value = null;
		showUnableToTailorModal.value = false;
        
		unableToTailorError.value = null;
		unableToTailorJobTitle.value = null;
	};

	const closeResumeModal = () => {
		selectedResume.value = null;
        
		isResumeModalVisible.value = false;
	};

	const showUploadResumeModal = () => {
		selectedResume.value = null;
        
		isUploadCustomModalVisible.value = true;
	};

	const closeUploadResumeModal = () => {
		selectedResume.value = null;
        
		isUploadCustomModalVisible.value = false;
	};

	return {
		selectedResume,
		isResumeModalVisible,
		isUploadCustomModalVisible,
		showUnableToTailorModal,
		showSideTab,
		unableToTailorJobTitle,
		unableToTailorError,

		showResumeModal,
		closeResumeModal,
		showUploadResumeModal,
		closeUploadResumeModal,
        
		setShowUnableToTailorModal,
		hideUnableToTailorModal,
        
		setShowSideTab,
		hideSideTab
	};
});
